import React, { useState, useEffect } from "react"
import { Row, Col, Button, Table, Spinner, Form } from "reactstrap"
import { useFormik } from "formik"

import FormikDatePicker from "../../Common/Formik/FormikDatePicker"
import FormikSelect from "../../Common/Formik/FormikSelect"
import GastosForm from "./GastosForm"
import Paginacion from "./Paginacion"

// Constantes
const hoy = new Date()
const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1)

const documentosOptions = [
  { value: 13, label: "Este Mismo" },
  { value: 14, label: "Nota Remisión" },
  { value: 15, label: "Factura" },
  { value: 16, label: "Recibo" },
]

const formaPagoOptions = [
  { value: 1, label: "Efectivo" },
  { value: 2, label: "Cheque" },
  { value: 3, label: "Vales" },
]

const costosOptions = [
  { value: 2, label: "Administración" },
  { value: 1, label: "Contabilidad" },
  { value: 3, label: "Extensión" },
  { value: 4, label: "Infraestructura y Mantenimiento" },
  { value: 5, label: "Investigación" },
  { value: 6, label: "Servicios Estudiantiles" },
  { value: 7, label: "Tecnología y Recursos Informáticos" },
]

const initialValuesConsulta = {
  Fecha_Inicio: primerDiaMes,
  Fecha_Fin: hoy,
}

const GastosConsulta = ({
  onBuscar,
  gastos = [],
  isLoading,
  conceptosGastoOptions = [],
}) => {
  const [gastoSeleccionado, setGastoSeleccionado] = useState(null)
  const [paginaActual, setPaginaActual] = useState(0)
  const [totalRegistros, setTotalRegistros] = useState(0)
  const [optionsPersonaRecibeRecurso, setOptionsPersonaRecibeRecurso] =
    useState([])
  const [optionsPersonaEntregoRecurso, setOptionsPersonaEntregoRecurso] =
    useState([])
  const [optionsPersonaAutorizoRecurso, setOptionsPersonaAutorizoRecurso] =
    useState([])

  const handleSeleccionarGasto = index => {
    setGastoSeleccionado(gastos[index])
    //console.log("gastoSeleccionado", gastos[index])
    setPaginaActual(index)
  }

  const handleOnChangeRecord = record => {
    setPaginaActual(record)
    setGastoSeleccionado(gastos[record - 1])
    // console.log("id_Gasto", gastos[record - 1].id_Gasto)
    // console.log("Folio", gastos[record - 1].Folio_Documento)
    // console.log("Importe", gastos[record - 1].Importe)
    // console.log(
    //   "Persona_Entrego_Recibo",
    //   gastos[record - 1].Descripcion_Persona_Entrego_Recibo
    // )
    // console.log("id_Centro_Costos", gastos[record - 1].id_Centro_Costos)
    // console.log("id_Concepto_Gasto", gastos[record - 1].id_Concepto_Gasto)
    // console.log("id_Documento", gastos[record - 1].id_Documento)
    // console.log("id_Forma_Pago", gastos[record - 1].id_Forma_Pago)
    // console.log("-------------------------------")
  }

  const handleNextRecord = () => {
    if (paginaActual < gastos.length - 1) {
      setPaginaActual(paginaActual + 1)
      setGastoSeleccionado(gastos[paginaActual + 1])
      console.log("gastoSeleccionado", gastos[paginaActual + 1])
    }
  }

  const handlePreviousRecord = () => {
    if (paginaActual > 0) {
      setPaginaActual(paginaActual - 1)
      setGastoSeleccionado(gastos[paginaActual - 1])
      console.log("gastoSeleccionado", gastos[paginaActual - 1])
    }
  }

  useEffect(() => {
    //console.log("gastos: ", gastos)
    if (gastos.length > 0) {
      handleSeleccionarGasto(0)
      setPaginaActual(1)
      setTotalRegistros(gastos.length)
    } else {
      setPaginaActual(0)
      setTotalRegistros(0)
    }
  }, [gastos])

  useEffect(() => {
    if (gastoSeleccionado) {
      const personaRecibe = {
        label: gastoSeleccionado.Descripcion_Persona_Recibo,
        value:
          gastoSeleccionado.Descripcion_Persona_Recibo.toLowerCase().replace(
            /\W/g,
            ""
          ),
      }
      const personaEntrego = {
        label: gastoSeleccionado.Descripcion_Persona_Entrego_Recibo,
        value:
          gastoSeleccionado.Descripcion_Persona_Entrego_Recibo.toLowerCase().replace(
            /\W/g,
            ""
          ),
      }
      const personaAutorizo = {
        label: gastoSeleccionado.Descripcion_Persona_Autorizadora_Operacion,
        value:
          gastoSeleccionado.Descripcion_Persona_Autorizadora_Operacion.toLowerCase().replace(
            /\W/g,
            ""
          ),
      }

      let nuevasOpciones = [...optionsPersonaRecibeRecurso, personaRecibe]
      setOptionsPersonaRecibeRecurso(nuevasOpciones)

      nuevasOpciones = [...optionsPersonaEntregoRecurso, personaEntrego]
      setOptionsPersonaEntregoRecurso(nuevasOpciones)

      nuevasOpciones = [...optionsPersonaAutorizoRecurso, personaAutorizo]
      setOptionsPersonaAutorizoRecurso(nuevasOpciones)
    }
  }, [gastoSeleccionado])

  // #region Formik form
  const formik = useFormik({
    initialValues: initialValuesConsulta,
    onSubmit: onBuscar,
    enableReinitialize: true,
  })
  // #endregion

  return (
    <div>
      {/* Formulario de Filtros */}

      <Form onSubmit={formik.handleSubmit}>
        <Row>
          <Col sm="5">
            <FormikDatePicker
              label="Fecha de Inicio"
              name="Fecha_Inicio"
              formik={formik}
            />
          </Col>

          <Col sm="5">
            <FormikDatePicker
              label="Fecha de Fin"
              name="Fecha_Fin"
              formik={formik}
            />
          </Col>

          {/* <Col sm="4">
            <FormikSelect
              label="Centro de Costos"
              name="id_Centro_Costos"
              options={costosOptions}
              formik={formik}
            />
          </Col>

          <Col sm="4">
            <FormikSelect
              label="Campus"
              name="id_Campus"
              options={campusOptions}
              formik={formik}
            />
          </Col> */}

          <Col sm="2">
            <div className="d-flex justify-content-end mt-4">
              <button
                type="submit"
                className="btn btn-primary w-md"
                // disabled={!formikConsulta.isValid}
              >
                Consultar
              </button>
            </div>
          </Col>
        </Row>
      </Form>
      <Row>
        {/* Control de Paginación */}
        <Paginacion
          totalPaginas={totalRegistros}
          paginaActual={paginaActual}
          onPaginaCambio={handleOnChangeRecord}
        />
      </Row>

      {/* Resultados de la Consulta */}
      <div className="mt-4">
        {isLoading && <Spinner color="primary" />}

        {!isLoading && gastos.length === 0 && (
          <p className="text-center">
            setPaginaActual No se encontraron gastos en el rango de fechas
            seleccionado.
          </p>
        )}

        {!isLoading && gastos.length > 0 && (
          <>
            {/* Tabla de Resultados
            <Table bordered responsive>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Persona que Recibió</th>
                  <th>Importe</th>
                  <th>Centro de Costos</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {gastos.map((gasto, index) => (
                  <tr key={gasto.id_Gasto}>
                    <td>{gasto.Fecha_Creacion}</td>
                    <td>{gasto.Descripcion_Persona_Recibo}</td>
                    <td>${gasto.Importe.toFixed(2)}</td>
                    <td>{gasto.id_Centro_Costos}</td>
                    <td>
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => handleSeleccionarGasto(index)}
                      >
                        Ver Detalle
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table> */}

            {/* Vista Detallada de un Gasto usando `GastosForm` */}
            {gastoSeleccionado && (
              <GastosForm
                initialValues={gastoSeleccionado}
                modo="consulta"
                handleNextRecord={handleNextRecord}
                handlePreviousRecord={handlePreviousRecord}
                isLoading={false}
                optionsPersonaRecibeRecurso={optionsPersonaRecibeRecurso}
                optionsPersonaEntregoRecurso={optionsPersonaEntregoRecurso}
                optionsPersonaAutorizoRecurso={optionsPersonaAutorizoRecurso}
                documentosOptions={documentosOptions}
                costosOptions={costosOptions}
                conceptosGastoOptions={conceptosGastoOptions}
                formaPagoOptions={formaPagoOptions}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default GastosConsulta
